import React, {useState, useEffect} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import InputText from '../../components/FormFields/InputText';
import TextArea from '../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import PageHeader from './components/PageHeader';
import {useHistory} from 'react-router-dom';
import {validDouble} from '../../utils/const';
import {
  GetPotentionalRisk,
  getPotentionalRisks,
  getAllSubProcesses,
  addIncurredRisk,
  getAllSubCauses,
  getDepartment,
} from '../../services/IncurredEvent/incurredEventApi';
import SelectList from '../../components/select/SelectList';
import {useUserContext} from '../../contexts/UserContext';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import Toast from '../../components/toast/Toast';
import Trash from './img/Trash.svg';
import Swal from 'sweetalert2';
import './addPotentionalRisk.scss';
import allowedFileTypes from '../../utils/allowedFileTypes';
import PreventTransitionPrompt from '../../components/preventTransitionprompt/PreventTransition';
import InputDate from "../../components/FormFields/inputDate/InputDate";
import {format} from "date-fns";
import LossModal from "./components/modals/LossModal";
import editImage from "./components/img/edit.svg";
import deleteImage from './components/img/delete.svg'

const AddIncurredRisk = (props) => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();
  const [disabled, setDisabled] = useState(true);
  const [disableSubprocess, setDisableSubPorcess] = useState(true);
  const [disableSubCauses, setDisableSubCauses] = useState(true);
  const [subProcesses, setSubProcesses] = useState([]);
  const [subCauses, setSubCauses] = useState([]);
  const [yesNoOptions,setYesNoOptions] = useState(  lang === 'eng'
      ? [{value: true, label: 'Yes'},{value:false,label:'No'}]
      : [{value: true, label: 'Da'},{value:false,label:'Ne'}])
  const [potentionalRisks, setPotentionalRisks] = useState([]);
  const [files, setFiles] = useState([]);
  const [riskEstimation, setRiskEstimation] = useState();
  const [isAdding, setIsAdding] = useState(true);
  const [lossModalOpen,setLossModalOpen] = useState(false);
  const [isEdit,setIsEdit] = useState(false);
  const [lossData, setLossData] = useState([]);
  const [currentID,setCurrentID] = useState();
  let history = useHistory();

  const [schema, setSchema] = useState(
    yup.object().shape({
      riskType: yup.object().nullable().required(t('message.fieldRequired')),
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      description: yup
        .string()
        .trim()
        .max(2048, t('message.max2048'))
        .required(t('message.fieldRequired')),
      riskCauseId: yup.object().nullable().required(t('message.fieldRequired')),
      riskSubCauseId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      creditRiskRelated: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholderId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskCategoryId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      userResponsibleId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      estimatedGrossLost: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .typeError(t('message.onlyDecimalNumbers')),
      riskMitigationModeName: yup.object().nullable().required(t('message.fieldRequired')),
      process: yup.object().nullable().required(t('message.fieldRequired')),
      subprocessId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      businessLineId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      typeGainLossId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      methodologyId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      comment: yup.string().trim().max(2048, t('message.max2048')),
      departmentSourceId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      eventOccurrence: yup
          .string()
          .nullable()
          .required(t('message.fieldRequired')),
    })
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, reset, setValue, setError, errors} = methods;
  const watchRiskType = watch('riskType');
  const watchProcess = watch('process');
  const watchRiskCause = watch('riskCauseId');
  const watchDepartmentSourceId = watch('departmentSourceId');

  const fetchSubprocesses = async () => {
    try {
      const {data} = await getAllSubProcesses(watchProcess['value']);
      return data;
    } catch (e) {}
  };
  const fetchSubcauses = async () => {
    try {
      const {data} = await getAllSubCauses(watchRiskCause['value']);
      return data;
    } catch (e) {}
  };

  const fetchPotentionalRisks = async () => {
    try {
      const {data} = await getPotentionalRisks();
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    fetchPotentionalRisks().then((r) => {
      let options = [];
      r.forEach((item) => {
        options.push({
          value: item.id,
          label: item.title,
        });
      });
      setPotentionalRisks(options);
    });

    if (
      props?.location?.state !== null &&
      props?.location?.state !== undefined
    ) {
      const potentialId = props?.location?.state.potentialId;
      const potentialTitle = props?.location?.state.potentialTitlе;
      setValue(
        'riskType',
        {value: potentialId, label: potentialTitle},
        {
          shouldValidate: false,
          shouldDirty: false,
        }
      );
    }
  }, []);
  useEffect(() => {
    if (watchRiskType?.value) {
      setDisabled(false);
      const fetchRiskData = async () => {
        try {
          const {data} = await GetPotentionalRisk(watchRiskType?.value);
          setRiskEstimation(data[0].riskEstimationId);
          setValue('description', data[0].description, {
            shouldValidate: true,
            shouldDirty: false,
          });
          if (data[0].estimatedGrossLost !== null) {
            setValue('estimatedGrossLost', data[0].estimatedGrossLost, {
              shouldValidate: true,
              shouldDirty: false,
            });
          }

          if (data[0].typeGainLossId !== null) {
            setValue(
              'typeGainLossId',
              {
                value: data[0].typeGainLossId,
                label:
                  lang === 'mne'
                    ? data[0].typeGainLossName
                    : data[0].typeGainLossNameEn,
              },
              {
                shouldValidate: true,
                shouldDirty: false,
              }
            );
          }
          setValue(
            'riskCauseId',
            {
              value: data[0].riskCauseId,
              label:
                lang === 'mne'
                  ? data[0].riskCauseName
                  : data[0].riskCauseNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue(
            'riskCategoryId',
            {
              value: data[0].riskCategoryId,
              label:
                lang === 'mne'
                  ? data[0].riskCategoryName
                  : data[0].riskCategoryNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue(
            'methodologyId',
            {
              value: data[0].methodologyId,
              label:
                lang === 'mne'
                  ? data[0].methodologyName
                  : data[0].methodologyNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue(
            'departmentStakeholderId',
            {
              value: data[0].departmentStakeholderId,
              label:
                lang === 'mne'
                  ? data[0].departmentStakeholderName
                  : data[0].departmentStakeholderNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
         
          if (data[0].businessLineId !== null) {
            setValue(
              'businessLineId',
              {
                value: data[0].businessLineId,
                label:
                  lang === 'mne'
                    ? data[0].businessLineName
                    : data[0].businessLineNameEn,
              },
              {
                shouldValidate: true,
                shouldDirty: false,
              }
            );
          }
          setValue(
            'subprocessId',
            {
              value: data[0].subprocessId,
              label:
                lang === 'mne'
                  ? data[0].subprocessName
                  : data[0].subprocessNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue(
            'riskSubCauseId',
            {
              value: data[0].riskSubCauseId,
              label:
                lang === 'mne'
                  ? data[0].riskSubCauseName
                  : data[0].riskSubCauseNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
          setValue(
            'process',
            {
              value: data[0].processId,
              label:
                lang === 'mne' ? data[0].processName : data[0].processNameEn,
            },
            {
              shouldValidate: true,
              shouldDirty: false,
            }
          );
        } catch (err) {
          // console.log(err, 'error');
        }
      };

      fetchRiskData();
    }
  }, [watchRiskType]);

  const handleCancel = (e) => {
    e.preventDefault();
    window.location = '/dashboard';
  };
  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const date =
        format(new Date(data.eventOccurrence), 'yyyy-MM-dd') +
        'T' +
        format(new Date(data.eventOccurrence), 'hh:mm:ss');
    const payload = {
      riskTypeId: 2,
      potentialRiskId: data.riskType.value,
      title: data.title,
      description: data.description,
      typeGainLossId: data.typeGainLossId.value,
      methodologyId: data.methodologyId.value,
      riskCauseId: data.riskCauseId.value,
      riskSubCauseId: data.riskSubCauseId.value,
      departmentStakeholderId: data.departmentStakeholderId.value,
      riskCategoryId: data.riskCategoryId.value,
      userResponsibleId: data.userResponsibleId.value,
      userResponsibleLogin: userDepartment[0].userResponsibleLogin,
      subprocessId: data.subprocessId.value,
      estimatedGrossLost: data.estimatedGrossLost,
      comment: data.comment,
      riskMitigationModeId: data.riskMitigationModeName.value,
      riskMitigationModeName: data.riskMitigationModeName.label,
      creditRiskRelated: data.creditRiskRelated.value,
      businessLineId: data.businessLineId.value,
      userCreatedId: user.id,
      riskEstimationId: riskEstimation,
      departmentSourceId: data.departmentSourceId.value,
      harmfulOperationalRiskOccurrenceDate: date,
      riskExpenseDTO: lossData.length > 0 ? lossData.map((item) => (
          {
            lossReason: {
              id:item.lossReason.value,
              name: item.lossReason.label
            },
            netLoss: item.netLoss,
            lossDate: item.lossDate
          }
      )) : []
    };
    try {
      const response = await addIncurredRisk(payload, files);
      if (response.status === 201) {
        await Toast.fire({
          title: t('message.addSuccess2', {entity: t('common.incurred-risk')}),
          icon: 'success',
        });
        setIsAdding(false);
      }
      await history.push(`/incurred-risk/${response.data.id}`);
    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Swal.fire({
          text:
            lang === 'eng'
              ? err.response.data.description
              : t('message.addRiskErrorExists'),
          icon: 'error',
        });
        document.getElementById('title').focus();
        document.getElementById('title').select();
      } else {
        Toast.fire({
          title: t('message.errorApi'),
          icon: 'error',
        });
        setIsAdding(false);
      }
    }
  };

  useEffect(() => {
    if (watchRiskCause?.value) {
      setDisableSubCauses(false);
      fetchSubcauses().then((r) => {
        let subCauses = [];
        r.forEach((item) => {
          subCauses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubCauses(subCauses);
      });
    }
    if (watchRiskCause === null) {
      setValue('riskSubCauseId', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCause]);
  useEffect(() => {
    if (watchProcess?.value) {
      setDisableSubPorcess(false);
      fetchSubprocesses().then((r) => {
        let subProcesses = [];
        r.forEach((item) => {
          subProcesses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubProcesses(subProcesses);
      });
    }
    if (watchProcess === null) {
      setValue('subprocessId', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchProcess]);

  const uploadOnChange = () => {
    const input = document.getElementById('upload');
    let children = [];
    if (input.files.length > 10) {
      Toast.fire({
        title: t('message.tooManyFiles'),
        icon: 'error',
      });
    } else {
      for (let i = 0; i < input.files.length; ++i) {
        if (input.files.item(i).size > 10485760) {
          Toast.fire({
            title: t('message.fileTooBig'),
            icon: 'error',
          });
        } else {
          children.push({
            id: input.files.item(i).name,
            label: input.files.item(i).name,
          });
          setFiles(children);
        }
      }
    }
  };

  const clearLocalFile = (index) => {
    const dt = new DataTransfer();
    const input = document.getElementById('upload');
    const {files} = input;
    let children = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (index !== i) {
        dt.items.add(file); // here you exclude the file. thus removing it.
        children.push({
          id: input.files.item(i).name,
          label: input.files.item(i).name,
        });
      }
    }
    input.files = dt.files;
    setFiles(children);
  };

  const onChangeEstimatedGrossLoss = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('estimatedGrossLost', result);
  };

  useEffect(() => {
    if (watchDepartmentSourceId) {
      const depratmentObject = async () => {
        try {
          const {data} = await getDepartment(watchDepartmentSourceId.value);
          setValue('userResponsibleId', {
            value: data[0].userResponsibleId,
            label:
              data[0].userResponsibleFirstName +
              ' ' +
              data[0].userResponsibleLastName,
          });
        } catch {}
      };
      depratmentObject();
    }
  }, [watchDepartmentSourceId]);


  const deleteConto = (id) => {
    setLossModalOpen(false);
    setLossData((prevLossData) => prevLossData.filter((item) => item.id !== id))
    Toast.fire({
      title: t('codebook.successfullyDeletedLoss'),
      icon: 'success',
    });
  }

  useEffect(() => {
    const index = lossData.findIndex((loss) => loss.id === currentID);
    if (index !== -1) {
      const selectedLoss = lossData[index];
      setValue(`lossData.${index}.account`, selectedLoss?.lossReason);
    }
  },[lossData])

  return (
    <>
      <PreventTransitionPrompt when={isAdding} />
      <PageHeader />
      <div className="main-form mt-4">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitForm)}>
            <Row className="field-group-title">
              <Col className="col-4 col-xl-2">
                {t('incurred-risk.mainData')}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col className="col-6 col-xl-3">
                <label className="label-incurred">
                  {t('incurred-risk.potentionalRisk')}
                </label>
                <SelectInfinite
                  api="/risks?riskTypeId.equals=1"
                  name="riskType"
                  placeholder={t('incurred-risk.placeholder.potentionalRisk')}
                  labelKey={'title'}
                  className="select"
                  isClearable
                  queryKeys={'title.contains'}
                />
                <label className="label-incurred">
                  {t('incurred-risk.title')}
                </label>
                <InputText
                  type="text"
                  name="title"
                  className="form-control input-field"
                  placeholder={t('incurred-risk.placeholder.title')}
                  disabled={disabled}
                  id="title"
                />
              </Col>
              <Col className="col-6 col-xl-3 ">
                <label className="label-incurred">
                  {t('incurred-risk.description')}
                </label>
                <TextArea
                  name="description"
                  className="form-control text-area"
                  placeholder={t('incurred-risk.placeholder.description')}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row className="mt-5 field-group-title">
              <Col className="col-4 col-xl-2">
                {t('incurred-risk.additionalInformation')}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('incurred-risk.category')}
                </label>
                <SelectInfinite
                  api="risk-categories"
                  name="riskCategoryId"
                  placeholder={t('incurred-risk.placeholder.category')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={disabled}
                />
                <label className="label-incurred">
                  {t('incurred-risk.riskCauses')}
                </label>
                <SelectInfinite
                  api="risk-causes"
                  name="riskCauseId"
                  placeholder={t('incurred-risk.placeholder.riskCauses')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={disabled}
                />
                <label className="label-incurred">
                  {t('incurred-risk.subCauses')}
                </label>

                <SelectList
                  name="riskSubCauseId"
                  isDisabled={disableSubCauses}
                  className="select"
                  placeholder={t('incurred-risk.placeholder.subCauses')}
                  options={subCauses}
                  isClearable
                />
                <label className="label-litigation">
                  {t('potentialRisk.dateOfEventOccurrence')}
                </label>
                <InputDate
                    name="eventOccurrence"
                    placeholder={t('potentialRisk.placeholder.selectDate')}
                    style={{height: '45px!important', width: '100%'}}
                    isClearable={true}
                    disabled={disableSubCauses}
                    // maxDate={new Date()}
                />
                <label className="label-incurred">
                  {t('incurred-risk.attachFile')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <InputText
                    id="upload"
                    type="file"
                    name="file"
                    multiple
                    className="file-input"
                    onChange={uploadOnChange}
                    disabled={disabled}
                    accept={allowedFileTypes}
                />
                <div key={files}>
                  <ul>
                    {files.map((file, index) => (
                        <li key={file.id}>
                          <div className="d-flex align-items-center">
                            <span className="mr-5">{file.label}</span>
                            <img
                                src={Trash}
                                alt="trash"
                                onClick={(e) => {
                                  e.preventDefault();
                                  clearLocalFile(index);
                                }}
                            />
                          </div>
                        </li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('incurred-risk.businessLines')}
                </label>
                <SelectInfinite
                  api="business-lines"
                  name="businessLineId"
                  placeholder={t('incurred-risk.placeholder.businessLines')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={disabled}
                />
                <label className="label-incurred">
                  {t('mitigation-measures.method')}
                </label>
                <SelectInfinite
                    api="/risk-mitigation-modes"
                    name="riskMitigationModeName"
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    placeholder={t('placeholder.riskMitigrationMethod')}
                    isDisabled={disabled}
                />
                <label className="label-incurred">
                  {t('incurred-risk.process')}
                </label>
                <SelectInfinite
                  api="processes"
                  name="process"
                  placeholder={t('incurred-risk.placeholder.process')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={disabled}
                />

                <label className="label-incurred">
                  {t('incurred-risk.subprocess')}
                </label>
                <SelectList
                  name="subprocessId"
                  isDisabled={disableSubprocess}
                  className="select"
                  placeholder={t('incurred-risk.placeholder.subprocess')}
                  options={subProcesses}
                  isClearable
                />
                {/*<label className="label-incurred">*/}
                {/*  PREVOD*/}
                {/*</label>*/}

                {/*<SelectList*/}
                {/*    name="riskSubCauseId"*/}
                {/*    isDisabled={disableSubCauses}*/}
                {/*    className="select"*/}
                {/*    placeholder={t('incurred-risk.placeholder.subCauses')}*/}
                {/*    options={subCauses}*/}
                {/*    isClearable*/}
                {/*/>*/}
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('incurred-risk.metodologies')}
                </label>
                <SelectInfinite
                  api="methodologies"
                  name="methodologyId"
                  placeholder={t('incurred-risk.placeholder.metodologies')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={disabled}
                />
                <label className="label-potential-risk">
                  {t('potentialRisk.departmentRisk')}
                </label>
                {userDepartment?.length === 1 ? (
                  <SelectInfinite
                    api="departments/departments-user-in-charge"
                    name="departmentSourceId"
                    placeholder={t('potentialRisk.placeholder.departmentRisk')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    defaultValue={{
                      value:
                        userDepartment[0]?.id !== undefined
                          ? userDepartment[0]?.id
                          : '',
                      label:
                        userDepartment[0]?.id !== undefined
                          ? lang === 'mne'
                            ? userDepartment[0]?.name
                            : userDepartment[0]?.nameEn
                          : '',
                    }}
                    isDisabled={true}
                  />
                ) : (
                  <SelectInfinite
                    api="departments/departments-user-in-charge"
                    name="departmentSourceId"
                    placeholder={t('potentialRisk.placeholder.departmentRisk')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    isDisabled={disabled}

                  />
                )}

                <label className="label-incurred">
                  {t('incurred-risk.department')}
                </label>
                <SelectInfinite
                  api="departments"
                  name="departmentStakeholderId"
                  placeholder={t('incurred-risk.placeholder.department')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isDisabled={disabled}
                />
                <label className="label-incurred">
                  {t('incurred-risk.typeGainLoss')}
                </label>
                <SelectInfinite
                    api="type-gain-losses"
                    name="typeGainLossId"
                    placeholder={t('incurred-risk.placeholder.typeGainLoss')}
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    isDisabled={disabled}
                />
              </Col>

              <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('incurred-risk.isEventConnected')}
                </label>

                <SelectList
                    name="creditRiskRelated"
                    className="select"
                    options={yesNoOptions}
                    placeholder={t('incurred-risk.isEventConnectedPlaceholder')}
                    isClearable={false}
                    errors={errors}
                    isDisabled={disabled}
                />

                <label className="label-incurred">
                  {t('incurred-risk.estimatedGrossLoss')}
                </label>
                <InputText
                    type="number"
                    name="estimatedGrossLost"
                    className="form-control input-field"
                    placeholder={t(
                        'incurred-risk.placeholder.estimatedGrossLoss'
                    )}
                    disabled={disabled}
                    step=".01"
                    min="0"
                    onChange={onChangeEstimatedGrossLoss}
                />
                <label className="label-incurred">
                  {t('incurred-risk.responsibleUser')}
                </label>
                <SelectInfinite
                    api="users"
                    name="userResponsibleId"
                    labelKey="firstName"
                    placeholder={t('incurred-risk.placeholder.responsibleUser')}
                    className="select"
                    // isDisabled={true}
                    defaultValue={{
                      value:
                          userDepartment[0]?.userResponsibleId !== undefined
                              ? userDepartment[0]?.userResponsibleId
                              : '',
                      label:
                          userDepartment[0]?.userResponsibleId !== undefined
                              ? userDepartment[0]?.userResponsibleFirstName +
                              ' ' +
                              userDepartment[0]?.userResponsibleLastName
                              : '',
                    }}
                />
                <label className="label-incurred">
                  {t('incurred-risk.additionalComment')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <TextArea
                    name="comment"
                    className="form-control text-area"
                    placeholder={t('incurred-risk.placeholder.additionalComment')}
                    disabled={disabled}
                />
              </Col>
            </Row>
            <Row className="mb-2 occured-loss-footer">
              <Col className="col-3 col-xl-3">
              <label className="label-incurred">
                {t('codebook.addIncurredLoss')}
              </label>
              <span className="optional register">
                  {t('common.optional')}
                </span>
              <p className={'file-input'} style={{marginBottom: '-8px'}} onClick={() => {
                setIsEdit(false)
                setLossModalOpen(true)
              }}></p>
              <LossModal
                  open={lossModalOpen}
                  setLossData={setLossData}
                  lossData={lossData}
                  id={currentID}
                  isEdit={isEdit}
                  isOpen={(e) => setLossModalOpen(e)}
              />
              </Col>
            </Row>
            <Row>
              {lossData.map((item,index) => (
                  <>
                    <Col className="col-3 col-xl-3">
                      <label className="label-incurred">
                        {t('codebook.codebook')}
                      </label>
                      <SelectInfinite
                          api="/loss-reasons"
                          name={`lossData.${index}.account`}
                          placeholder={t('incurred-risk.placeholder.category')}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          isDisabled={true}
                          defaultValue={item?.lossReason}
                      />
                    </Col>
                    <Col className="col-3 col-xl-3" style={{marginRight: '5px'}}>
                      <label className="label-incurred">
                        {t('codebook.lossDate')}
                      </label>
                      <InputDate
                          name="lossDate"
                          selected={new Date(item?.lossDate)}
                          placeholder={t('codebook.lossDatePlaceholder')}
                          style={{height: '65px!important'}}
                          forceSelected={true}
                          disabled={true}
                          isClearable={false}
                      />
                    </Col>
                    <Col className="col-3 col-xl-3" style={{marginRight: '5px'}}>
                      <label className="label-incurred">
                        {t('codebook.loss')}
                      </label>
                      <InputText
                          type="text"
                          name="netLoss"
                          className="form-control input-field"
                          placeholder={t('incurred-risk.placeholder.title')}
                          disabled={true}
                          value={item?.netLoss}
                      />
                    </Col>
                    <div style={{width: '10%',display:'flex',marginLeft: '20px',alignItems:'center'}}>
                      <img style={{marginTop: '30px',marginRight: '5px',cursor: 'pointer'}} onClick={() => {
                        setLossModalOpen(true)
                        setCurrentID(item.id)
                        setIsEdit(true);
                      }} src={editImage} alt={'edit'}/>
                      <img style={{marginTop: '30px',cursor: 'pointer'}} onClick={() => deleteConto(item.id)} src={deleteImage} alt={'delete'}/>
                    </div>
                  </>
              ))}
            </Row>
            <Row className="mt-3 form-footer">
              <button
                className="secondary-btn"
                type="reset"
                onClick={handleCancel}
              >
                {t('buttons.cancel')}
              </button>
              <button className="primary-btn" type="submit">
                {t('buttons.save')}
              </button>
            </Row>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

export default AddIncurredRisk;
